export default "__VITE_ASSET__Dii_1U8O__"